import { isSprinkler, sprayR, sprayArc } from './spray';

// irrigation coverage of the drawn garden areas: grid cells counted by how many sprinkler throw sectors reach them
const num = (v, d) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return Number.isFinite(n) ? n : d; };
// paved / gravel-only areas do not need water; manual switch g.water overrides
export const needsWater = (g) => (g.water != null ? !!g.water : !(g.land && num(g.land.turfPct, 100) + num(g.land.topsoilPct, 100) + num(g.land.mulchPct, 0) === 0));

const inPoly = (x, y, P) => {
  let c = false;
  for (let i = 0, j = P.length - 1; i < P.length; j = i++) {
    if ((P[i][1] > y) !== (P[j][1] > y) && x < ((P[j][0] - P[i][0]) * (y - P[i][1])) / (P[j][1] - P[i][1]) + P[i][0]) c = !c;
  }
  return c;
};

// strict = professional head-to-head rule: only overlapping sprinklers count as good
export function areaCoverage(g, fittings, strict = false) {
  const lat0 = g.pts[0][0], mLat = 111320, mLon = 111320 * Math.cos((lat0 * Math.PI) / 180);
  const xy = (la, lo) => [(lo - g.pts[0][1]) * mLon, (la - lat0) * mLat];
  const P = g.pts.map((p) => xy(p[0], p[1]));
  const xs = P.map((p) => p[0]), ys = P.map((p) => p[1]);
  const [x0, x1, y0, y1] = [Math.min(...xs), Math.max(...xs), Math.min(...ys), Math.max(...ys)];
  const cell = Math.max(0.5, Math.sqrt(((x1 - x0) * (y1 - y0)) / 3000));
  const spr = (fittings || []).filter(isSprinkler).map((f) => ({ c: xy(f.lat, f.lon), r: sprayR(f), arc: sprayArc(f), dir: +f.dir || 0 }));
  const cells = [];
  let dry = 0, weak = 0, ok = 0;
  for (let y = y0 + cell / 2; y < y1; y += cell) {
    for (let x = x0 + cell / 2; x < x1; x += cell) {
      if (!inPoly(x, y, P)) continue;
      // reached sprinklers; the outer 20 % of a throw radius gets clearly less water (single coverage there = weak)
      let n = 0, core = false;
      spr.forEach((s) => {
        const dx = x - s.c[0], dy = y - s.c[1], d2 = dx * dx + dy * dy;
        if (d2 > s.r * s.r) return;
        if (s.arc < 360 && Math.abs(((Math.atan2(dx, dy) * 180) / Math.PI - s.dir + 540) % 360 - 180) > s.arc / 2) return;
        n += 1;
        if (d2 <= (0.8 * s.r) ** 2) core = true;
      });
      const good = n >= 2 || (!strict && core);
      if (n === 0) dry++; else if (!good) weak++; else ok++;
      if (!good) cells.push({ n, b: [[lat0 + (y - cell / 2) / mLat, g.pts[0][1] + (x - cell / 2) / mLon], [lat0 + (y + cell / 2) / mLat, g.pts[0][1] + (x + cell / 2) / mLon]] });
    }
  }
  const tot = dry + weak + ok || 1;
  return { cells, dry: Math.round((dry / tot) * 100), weak: Math.round((weak / tot) * 100), ok: Math.max(0, 100 - Math.round((dry / tot) * 100) - Math.round((weak / tot) * 100)) };
}
